import { useEffect } from "react";

import DoneIcon from "@mui/icons-material/Done";
import { Button, Container, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface Props {
  email: string | null;
}

export function VerifySuccess(props: Props) {
  const { email } = props;
  const encodedEmail = encodeURIComponent(email ?? "");
  const url = `/login?email=${encodedEmail}`;

  const navigate = useNavigate();
  useEffect(() => {
    const timeoutId = window.setTimeout(() => navigate(url), 3000);

    return () => window.clearTimeout(timeoutId);
  }, [navigate, url]);

  return (
    <Container maxWidth="lg">
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <DoneIcon color="success" />
          <Typography variant="h5">Your account has been verified</Typography>
        </Stack>
        <Typography>
          You will be redirected shortly. If you are not redirected, please
          click the button to login.
        </Typography>
        <Button variant="contained" onClick={() => navigate(url)}>
          Login
        </Button>
      </Stack>
    </Container>
  );
}
